import { useTranslation } from "react-i18next";

export function useUrbanPointsSettingsFields(values, setValues, error, setError, onError) {
    const { t } = useTranslation();

    return [
        {
            type: "switch",
            name: "isActiveUrbanPoints",
            label: t('activeUrbanPoints'),
            control: String(values.isActiveUrbanPoints) === "true",
            onChange: (event) => {
                let newValues = { ...values };
                newValues[event.target.name] = event.target.checked;
                delete newValues.startDateUrbanPoints
                delete newValues.endDateUrbanPoints
                delete newValues.multiplier
                delete newValues.homeWorkPointsTolerance
                delete newValues.isActiveDateTimeSlotMultiplier
                delete newValues.endDateBonus
                delete newValues.startDateBonus
                delete newValues.endTimeBonus
                delete newValues.startTimeBonus
                setValues(newValues);
                onError(false);
                setError({});
            },
            xs: 12
        },
        {
            type: "date",
            name: "startDateUrbanPoints",
            label: t('startDateUrbanPoints'),
            condition1: values.isActiveUrbanPoints + "" === "true",
            xs: 6,
        },
        {
            type: "date",
            name: "endDateUrbanPoints",
            label: t('endDateUrbanPoints'),
            condition1: values.isActiveUrbanPoints + "" === "true",
            xs: 6,
        },
        {
            type: "number",
            name: "multiplier",
            label: t('multiplier'),
            condition1: values.isActiveUrbanPoints + "" === "true",
            startAdornment: "x",
            min: 0,
            required: true,
            step: 0.01,
            xs: 6,
        },
        {
            type: "number",
            name: "homeWorkPointsTolerance",
            label: t('homeWorkPointsTolerance'),
            condition1: values.isActiveUrbanPoints + "" === "true",
            startAdornment: t('meters'),
            min: 0,
            required: true,
            tooltip: t('homeWorkPointsToleranceExplain'),
            xs: 6,
        },
        {
            type: "switch",
            name: "isActiveDateTimeSlotMultiplier",
            label: t('multiplierValid'),
            control: String(values.isActiveDateTimeSlotMultiplier) === "true",
            condition1: values.isActiveUrbanPoints + "" === "true",
            onChange: (event) => {
                setValues({ ...values, [event.target.name]: event.target.checked })
                delete values.startDateBonus
                delete values.endDateBonus
                delete values.startTimeBonus
                delete values.endTimeBonus
                delete error["startDateBonus"]
                delete error["endDateBonus"]
                delete error["startTimeBonus"]
                delete error["endTimeBonus"]
                if (Object.keys(error).length === 0) onError(false)
            },
            xs: 12
        },
        {
            type: "date",
            name: "startDateBonus",
            label: t('startDateBonus'),
            condition1: values.isActiveUrbanPoints + "" === "true",
            condition2: values.isActiveDateTimeSlotMultiplier + "" === "true",
            required: true,
            xs: 6,
        },
        {
            type: "date",
            name: "endDateBonus",
            label: t('endDateBonus'),
            condition1: values.isActiveUrbanPoints + "" === "true",
            condition2: values.isActiveDateTimeSlotMultiplier + "" === "true",
            required: true,
            xs: 6,
        }
    ]
}

export function useCouponsExpirationDateSettingsFields(values, setValues, error, setError, onError) {
    const { t } = useTranslation();

    return [
        {
            type: "date",
            name: "couponExpireDate",
            label: t('couponsExpirationDate'),
            xs: 6,
        }
    ]
}

export function useRefundsFields(values, setValues) {
    const { t } = useTranslation();

    return [
        {
            type: "radio",
            label: t('typeThresholdForRefund'),
            name: "typeThresholdForRefund",
            options: [
                {
                    value: "km",
                    label: t('km')
                },
                {
                    value: "euro",
                    label: t('euro')
                }
            ],
            xs: 6,
        },
        {
            type: "number",
            name: "minThresholdForRefund",
            label: t('minThresholdForRefund'),
            startAdornment: values.typeThresholdForRefund === "euro" ? "€" : t('km'),
            min: 0,
            step: values.typeThresholdForRefund === "euro" ? 0.01 : 1,
            required: true,
            tooltip: values.typeThresholdForRefund === "euro" ? t('minThresholdForRefundExplainEuro') : t('minThresholdForRefundExplainKm'),
            xs: 6,
        },
        {
            type: "radio",
            label: t('couponRefundType'),
            name: "couponRefundType",
            options: [
                {
                    value: "esercenti",
                    label: t('vendors')
                },
                {
                    value: "pa",
                    label: t('publicAdministration')
                }
            ],
            xs: 12,
        },
        {
            type: "switch",
            name: "ibanRequirement",
            label: t('ibanRequired'),
            control: String(values.ibanRequirement) === "true",
            onChange: (event) => {
                setValues({ ...values, [event.target.name]: event.target.checked })
            },
            xs: 12
        },
        {
            type: "switch",
            name: "serialNumberRequirement",
            label: "Richiedi Matricola Pinbiker",
            control: String(values.serialNumberRequirement) === "true",
            onChange: (event) => {
                setValues({ ...values, [event.target.name]: event.target.checked })
            },
            xs: 12
        },
        {
            type: "switch",
            name: "fiscalCodeRequirement",
            label: "Richiedi Codice Fiscale",
            control: String(values.fiscalCodeRequirement) === "true",
            onChange: (event) => {
                setValues({ ...values, [event.target.name]: event.target.checked })
            },
            xs: 12
        },
        {
            type: "number",
            name: "minUrbanPointsForRefund",
            label: t('minUrbanPointsForRefund'),
            startAdornment: t('points'),
            min: 0,
            tooltip: t('minUrbanPointsForRefundExplain'),
            xs: 6,
        },
        {
            type: "number",
            name: "euroMaxRefundInADay",
            label: t('euroMaxRefundInADay'),
            startAdornment: "€",
            min: 0,
            step: 0.01,
            tooltip: t('valueNullMeaning'),
            xs: 6,
        },
        {
            type: "number",
            name: "euroMaxRefundInAMonth",
            label: t('euroMaxRefundInAMonth'),
            startAdornment: "€",
            min: 0,
            step: 0.01,
            tooltip: t('valueNullMeaning'),
            xs: 6,
        },
        {
            type: "number",
            name: "euroMaxRefundInATime",
            label: t('euroMaxRefundInATime'),
            startAdornment: "€",
            min: 0,
            step: 0.01,
            tooltip: t('valueNullMeaning'),
            xs: 6,
        },
    ]
}

export function useHomeWorkRefundsFields(values, setValues, setError, onError) {
    const { t } = useTranslation();

    return [
        {
            type: "switch",
            name: "isActiveHomeWorkRefunds",
            label: t('isActiveHomeWorkRefunds'),
            control: String(values.isActiveHomeWorkRefunds) === "true",
            onChange: (event) => {
                let newValues = { ...values };
                newValues[event.target.name] = event.target.checked;
                delete newValues.emailAddressApprovalManager
                event.target.checked ? newValues.homeWorkRefundType = "urbanPoints" : delete newValues.homeWorkRefundType
                delete newValues.euroMaxRefundInADay
                delete newValues.euroMaxRefundInAMonth
                delete newValues.euroMaxRefundInATime
                delete newValues.valueKmHomeWorkBike
                delete newValues.valueKmHomeWorkElectricBike
                delete newValues.homeWorkPathTolerancePerc
                setValues(newValues);
                onError(false);
                setError({});
            }
        },
        {
            type: "switch",
            name: "addressValidation",
            label: t('addressValidationResponsible'),
            control: String(values.addressValidation) === "true",
            condition1: values.isActiveHomeWorkRefunds + "" === "true",
            onChange: (event) => {
                let newValues = { ...values };
                newValues[event.target.name] = event.target.checked;
                delete newValues.emailAddressApprovalManager
                setValues(newValues);
            }
        },
        {
            type: "text",
            name: "emailAddressApprovalManager",
            label: t('emailAddressApprovalManager'),
            condition1: values.isActiveHomeWorkRefunds + "" === "true",
            condition2: values.addressValidation + "" === "true",
            required: true,
            tooltip: t('emailAddressApprovalManagerExplain'),
            xs: 12,
        },
        {
            type: "radio",
            label: t('homeWorkRefundType'),
            name: "homeWorkRefundType",
            onChange: (newValue) => {
                let newValues = { ...values };
                newValues["homeWorkRefundType"] = newValue;
                setValues(newValues);
            },
            options: [{ value: "urbanPoints", label: t('initiativePoints') }, { value: "euro", label: t('euro') }],
            condition1: values.isActiveHomeWorkRefunds + "" === "true",
            xs: 6,
        },
        {
            type: "number",
            name: "valueKmHomeWorkBike",
            label: t('valueKmHomeWorkBike'),
            condition1: values.isActiveHomeWorkRefunds + "" === "true",
            startAdornment: values.homeWorkRefundType === "euro" ? "€" : t('points'),
            min: 0,
            required: true,
            step: values.homeWorkRefundType === "euro" ? 0.01 : 1,
            tooltip: values.homeWorkRefundType === "euro" ? t('valueKmHomeWorkBikeExplainEuro') : t('valueKmHomeWorkBikeExplainPoints'),
            xs: 12,
        },
        {
            type: "number",
            name: "valueKmHomeWorkElectricBike",
            label: t('valueKmHomeWorkElectricBike'),
            condition1: values.isActiveHomeWorkRefunds + "" === "true",
            startAdornment: values.homeWorkRefundType === "euro" ? "€" : t('points'),
            min: 0,
            step: values.homeWorkRefundType === "euro" ? 0.01 : 1,
            tooltip: values.homeWorkRefundType === "euro" ? t('valueKmHomeWorkElectricBikeExplainEuro') : t('valueKmHomeWorkElectricBikeExplainPoints'),
            xs: 12,
        },
        {
            type: "number",
            name: "homeWorkPathTolerancePerc",
            label: t('homeWorkPathTolerancePerc'),
            condition1: values.isActiveHomeWorkRefunds + "" === "true",
            startAdornment: "%",
            min: 0,
            required: true,
            tooltip: t('homeWorkPathTolerancePercExplain'),
            xs: 12,
            onChange: (value) => {
                let newValues = { ...values };
                if (value < 0) newValues["homeWorkPathTolerancePerc"] = 0;
                else newValues["homeWorkPathTolerancePerc"] = value;
                setValues(newValues);
            }
        }
    ]
}

export function useUrbanPathRefundsFields(values, setValues, setError, onError) {
    const { t } = useTranslation();

    return [
        {
            type: "switch",
            name: "isActiveUrbanPathRefunds",
            label: t('isActiveUrbanPathRefunds'),
            control: String(values.isActiveUrbanPathRefunds) === "true",
            onChange: (event) => {
                let newValues = { ...values };
                newValues[event.target.name] = event.target.checked;
                delete newValues.euroValueKmUrbanPathBike
                delete newValues.euroValueKmUrbanPathElectricBike
                setValues(newValues);
                onError(false);
                setError({});
            }
        },
        {
            type: "number",
            name: "euroValueKmUrbanPathBike",
            label: t('euroValueKmUrbanPathBike'),
            condition1: values.isActiveUrbanPathRefunds + "" === "true",
            startAdornment: "€",
            min: 0,
            step: 0.01,
            required: true,
            xs: 12,
        },
        {
            type: "number",
            name: "euroValueKmUrbanPathElectricBike",
            label: t('euroValueKmUrbanPathElectricBike'),
            condition1: values.isActiveUrbanPathRefunds + "" === "true",
            startAdornment: "€",
            tooltip: t('euroValueKmUrbanPathElectricBikeExplain'),
            min: 0,
            step: 0.01,
            xs: 12,
        }
    ]
}

export function useCustomFieldManagerFields(values, setValues) {
    const { t } = useTranslation();

    return [
        {
            type: "switch",
            name: "exclusiveCustomField",
            label: t('exclusiveCustomField'),
            control: String(values.exclusiveCustomField) === "true",
            onChange: (event) => {
                let newValues = { ...values };
                newValues[event.target.name] = event.target.checked;
                setValues(newValues);
            },
            xs: 12
        }
    ]
}

export function useGlobalRanksAchievementsManagerFields(values, setValues) {
    const { t } = useTranslation();

    return [
        {
            type: "switch",
            name: "canViewGlobalRanksAchievements",
            label: t('canViewGlobalRanksAchievements'),
            control: String(values.canViewGlobalRanksAchievements) === "true",
            onChange: (event) => {
                let newValues = { ...values };
                newValues[event.target.name] = event.target.checked;
                setValues(newValues);
            },
            xs: 12
        },
        {
            type: "switch",
            name: "isActiveAwardRankingsGlobalKey",
            label: t('isActiveAwardRankingsGlobalKey'),
            control: String(values.isActiveAwardRankingsGlobalKey) === "true",
            onChange: (event) => {
                let newValues = { ...values };
                newValues[event.target.name] = event.target.checked;
                setValues(newValues);
            },
            xs: 12
        }
    ]
}

export function useVendorsManagerFields(values, setValues) {
    const { t } = useTranslation();

    return [
        {
            type: "switch",
            name: "hasVendorFunctionality",
            label: t('hasVendorFunctionality'),
            control: String(values.hasVendorFunctionality) === "true",
            onChange: (event) => {
                let newValues = { ...values };
                newValues[event.target.name] = event.target.checked;
                setValues(newValues);
            },
            xs: 12
        },
        {
            type: "radio",
            name: "shopAssociationType",
            label: t('shopAssociation'),
            options: [
                {
                    label: t('manual'), value: "0",
                },
                {
                    label: t('automaticUrbanArea'), value: "1",
                },
                {
                    label: t('automaticIstatCode'), value: "2",
                },
            ],
            onChange: (event) => {
                let newValues = { ...values };
                newValues.shopAssociationType = event;
                setValues(newValues);
            },
            xs: 12
        }
    ]
}
